import React from "react";
import { BrowserRouter, Switch, Route as RouterRoute } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
// import Signup from "../pages/Signup/"; // signup desabilitado — cadastro nao publico
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import Clients from "../pages/Clients/";
import ClientDuplicates from "../pages/ClientDuplicates/";
import ClientDetail from "../pages/ClientDetail/";
import ClientStatuses from "../pages/ClientStatuses/";
import ClientSources from "../pages/ClientSources/";
import ClientTags from "../pages/ClientTags/";
import ClientFieldDefinitions from "../pages/ClientFieldDefinitions/";
import EmailAccounts from "../pages/EmailAccounts";
import Forms from "../pages/Forms";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Agenda from "../pages/Agenda/";
import Profile from "../pages/Profile/";
import AuditLogs from "../pages/AuditLogs/";
import Products from "../pages/Products/";
import ProductCategories from "../pages/ProductCategories/";
import LostReasons from "../pages/LostReasons/";
import Pipelines from "../pages/Pipelines/";
import Deals from "../pages/Deals/";
import FinanceAccounts from "../pages/FinanceAccounts/";
import FinanceCategories from "../pages/FinanceCategories/";
import CostCenters from "../pages/CostCenters/";
import FinancePayables from "../pages/Finance/Payables";
import FinanceReceivables from "../pages/Finance/Receivables";
import FinanceTransactions from "../pages/Finance/Transactions";
import FinanceDashboard from "../pages/Finance/Dashboard";
import PaymentGateways from "../pages/PaymentGateways/";
import Projects from "../pages/Projects/";
import ProjectDetail from "../pages/ProjectDetail/";
import Tasks from "../pages/Tasks/";
import Goals from "../pages/Goals/";
import Dashboards from "../pages/Dashboards/";
import Productivity from "../pages/Productivity/";
import ClientScores from "../pages/ClientScores/";
import ScoreRules from "../pages/ScoreRules/";
import Automations from "../pages/Automations/";
import AutomationLogs from "../pages/AutomationLogs/";
import PushSettings from "../pages/PushSettings/";
import ApiTokens from "../pages/ApiTokens/";
import Departments from "../pages/Departments/";
import AiFlows from "../pages/AiFlows/";
import AiConsumption from "../pages/AiConsumption/";
import AiFlowEditor from "../pages/AiFlows/FlowEditor";
import AiFlowExecutions from "../pages/AiFlowExecutions/";
import Campaigns from "../pages/Campaigns/";
import KnowledgeBase from "../pages/KnowledgeBase/";
import Proposals from "../pages/Proposals/";
import Forecast from "../pages/Forecast/";
import Subscriptions from "../pages/Subscriptions/";
import Orders from "../pages/Orders/";
import OrderDetail from "../pages/OrderDetail/";
import Approvals from "../pages/Approvals/";
import Contracts from "../pages/Contracts/";
import KeyDates from "../pages/KeyDates/";
import TagFunnel from "../pages/TagFunnel/";
import SalesAnalytics from "../pages/SalesAnalytics/";
import OutboundWebhooks from "../pages/OutboundWebhooks/";
import DealAttention from "../pages/DealAttention/";
import Cadences from "../pages/Cadences/";
import PublicProposal from "../pages/PublicProposal/";
import PublicForm from "../pages/PublicForm";
import OperationsAnalytics from "../pages/OperationsAnalytics/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            {/*
              Página do cliente. Usa o Route cru do react-router de propósito:
              o Route customizado redireciona usuário autenticado para "/" em
              qualquer rota não-privada, e esta precisa abrir para qualquer um,
              logado ou não.
            */}
            <RouterRoute exact path="/proposta/:token" component={PublicProposal} />
            {/* Formulário público: RouterRoute cru, para não redirecionar quem
                está logado — o operador precisa conseguir abrir o link para
                conferir o que o cliente vê. */}
            <RouterRoute exact path="/f/:slug" component={PublicForm} />
            {/* <Route exact path="/signup" component={Signup} /> */}
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/clients" component={Clients} isPrivate />
                <Route exact path="/client-duplicates" component={ClientDuplicates} isPrivate />
                <Route exact path="/clients/:clientId" component={ClientDetail} isPrivate />
                <Route exact path="/client-statuses" component={ClientStatuses} isPrivate />
                <Route exact path="/client-sources" component={ClientSources} isPrivate />
                <Route exact path="/client-tags" component={ClientTags} isPrivate />
                <Route exact path="/client-field-definitions" component={ClientFieldDefinitions} isPrivate />
                <Route exact path="/email-accounts" component={EmailAccounts} isPrivate />
                <Route exact path="/forms" component={Forms} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
                <Route exact path="/settings" component={Settings} isPrivate />
                <Route exact path="/Queues" component={Queues} isPrivate />
                <Route exact path="/agenda" component={Agenda} isPrivate />
                <Route exact path="/profile" component={Profile} isPrivate />
                <Route exact path="/audit-logs" component={AuditLogs} isPrivate />
                <Route exact path="/products" component={Products} isPrivate />
                <Route exact path="/product-categories" component={ProductCategories} isPrivate />
                <Route exact path="/lost-reasons" component={LostReasons} isPrivate />
                <Route exact path="/pipelines" component={Pipelines} isPrivate />
                <Route exact path="/deals" component={Deals} isPrivate />
                <Route exact path="/finance/accounts" component={FinanceAccounts} isPrivate />
                <Route exact path="/finance/categories" component={FinanceCategories} isPrivate />
                <Route exact path="/finance/cost-centers" component={CostCenters} isPrivate />
                <Route exact path="/finance/payables" component={FinancePayables} isPrivate />
                <Route exact path="/finance/receivables" component={FinanceReceivables} isPrivate />
                <Route exact path="/finance/transactions" component={FinanceTransactions} isPrivate />
                <Route exact path="/finance/dashboard" component={FinanceDashboard} isPrivate />
                <Route exact path="/payment-gateways" component={PaymentGateways} isPrivate />
                <Route exact path="/projects" component={Projects} isPrivate />
                <Route exact path="/projects/:id" component={ProjectDetail} isPrivate />
                <Route exact path="/tasks" component={Tasks} isPrivate />
                <Route exact path="/goals" component={Goals} isPrivate />
                <Route exact path="/dashboards" component={Dashboards} isPrivate />
                <Route exact path="/productivity" component={Productivity} isPrivate />
                <Route exact path="/scores/clients" component={ClientScores} isPrivate />
                <Route exact path="/scores/rules" component={ScoreRules} isPrivate />
                <Route exact path="/automations" component={Automations} isPrivate />
                <Route exact path="/automations/logs" component={AutomationLogs} isPrivate />
                <Route exact path="/notifications" component={PushSettings} isPrivate />
                <Route exact path="/api-tokens" component={ApiTokens} isPrivate />
                <Route exact path="/departments" component={Departments} isPrivate />
                <Route exact path="/ai-flows" component={AiFlows} isPrivate />
                <Route exact path="/ai-consumption" component={AiConsumption} isPrivate />
                <Route exact path="/ai-flows/:id" component={AiFlowEditor} isPrivate />
                <Route exact path="/ai-flows/:id/executions" component={AiFlowExecutions} isPrivate />
                <Route exact path="/campaigns" component={Campaigns} isPrivate />
                <Route exact path="/knowledge-base" component={KnowledgeBase} isPrivate />
                <Route exact path="/proposals" component={Proposals} isPrivate />
                <Route exact path="/forecast" component={Forecast} isPrivate />
                <Route exact path="/subscriptions" component={Subscriptions} isPrivate />
                <Route exact path="/orders" component={Orders} isPrivate />
                <Route exact path="/orders/:id" component={OrderDetail} isPrivate />
                <Route exact path="/approvals" component={Approvals} isPrivate />
                <Route exact path="/contracts" component={Contracts} isPrivate />
                <Route exact path="/key-dates" component={KeyDates} isPrivate />
                <Route exact path="/analytics/tag-funnel" component={TagFunnel} isPrivate />
                <Route exact path="/analytics/sales" component={SalesAnalytics} isPrivate />
                <Route exact path="/outbound-webhooks" component={OutboundWebhooks} isPrivate />
                <Route exact path="/deal-attention" component={DealAttention} isPrivate />
                <Route exact path="/cadences" component={Cadences} isPrivate />
                <Route exact path="/analytics/operations" component={OperationsAnalytics} isPrivate />
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
